/**
 * Parsea un número a formato con exactamente dos decimales
 * @param value - El valor a parsear (number, string, o undefined)
 * @param defaultValue - Valor por defecto si el input es inválido (default: 0)
 * @returns Número formateado con dos decimales
 */
export const parseNumber2Digits = (value: number | string | undefined, defaultValue: number = 0): string => {
  if (value === undefined || value === null || value === '') {
    return defaultValue.toFixed(2);
  }
  
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  
  if (isNaN(numValue)) {
    return defaultValue.toFixed(2);
  }
  
  return numValue.toFixed(2);
};

/**
 * Parsea un número y lo retorna como number con dos decimales
 * @param value - El valor a parsear
 * @param defaultValue - Valor por defecto si el input es inválido
 * @returns Número con dos decimales
 */
export const parseNumberToFixed2 = (value: number | string | undefined, defaultValue: number = 0): number => {
  const parsed = parseNumber2Digits(value, defaultValue);
  return parseFloat(parsed);
};

/**
 * Formatea un número para mostrar en inputs (sin comas)
 * @param value - El valor a formatear
 * @returns String formateado para input
 */
export const formatNumberForInput = (value: number | string | undefined): string => {
  if (value === undefined || value === null || value === '') {
    return '';
  }
  
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  
  if (isNaN(numValue)) {
    return '';
  }
  
  return numValue.toString();
};

/**
 * Formatea un número para mostrar con comas como separador de miles
 * @param value - El valor a formatear
 * @returns String formateado con comas
 */
export const formatNumberWithCommas = (value: number | string | undefined): string => {
  const parsed = parseNumber2Digits(value);
  const number = parseFloat(parsed);
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(number);
};
